import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiInfo, FiExternalLink, FiMessageCircle, FiZap, FiTarget } = FiIcons;

const TaskDetailModal = ({ isOpen, onClose, task }) => {
  if (!isOpen || !task) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden"
      >
        <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
          <div className="flex items-center gap-2">
            <div className={`p-2 rounded-lg ${task.priority === 'High' ? 'bg-red-50 text-red-600' : 'bg-blue-50 text-blue-600'}`}>
              <SafeIcon icon={FiTarget} className="w-5 h-5" />
            </div>
            <h2 className="text-lg font-bold text-gray-900">Task Intelligence</h2>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-gray-200 rounded-full text-gray-400 transition-colors">
            <SafeIcon icon={FiX} />
          </button>
        </div>

        <div className="p-8 space-y-8">
          <div>
            <h3 className="text-2xl font-bold text-gray-900 leading-tight mb-4">{task.text}</h3>
            <div className="flex flex-wrap gap-3">
              <span className="px-3 py-1 bg-gray-100 text-gray-600 rounded-full text-xs font-bold uppercase tracking-wider">
                {task.category}
              </span>
              <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider ${
                task.priority === 'High' ? 'bg-red-100 text-red-700' : 'bg-orange-100 text-orange-700'
              }`}>
                {task.priority} Priority
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-blue-50 rounded-2xl p-5 border border-blue-100">
              <h4 className="text-xs font-bold text-blue-900 uppercase tracking-widest mb-3 flex items-center gap-2">
                <SafeIcon icon={FiInfo} /> Why this matters
              </h4>
              <p className="text-sm text-blue-800 leading-relaxed">
                This item was generated from your <strong>{task.source}</strong>. Improving this area typically correlates with a 15-20% increase in departmental efficiency.
              </p>
            </div>

            <div className="bg-purple-50 rounded-2xl p-5 border border-purple-100">
              <h4 className="text-xs font-bold text-purple-900 uppercase tracking-widest mb-3 flex items-center gap-2">
                <SafeIcon icon={FiZap} /> Expert Tip
              </h4>
              <p className="text-sm text-purple-800 leading-relaxed">
                Start by identifying the primary stakeholder. Documentation usually takes 4-6 hours but saves 20+ hours of onboarding later.
              </p>
            </div>
          </div>

          <div className="pt-6 border-t border-gray-100 flex flex-col sm:flex-row gap-3">
            <button className="flex-1 py-4 bg-gray-900 text-white rounded-xl font-bold hover:bg-slate-800 shadow-md transition-all flex items-center justify-center gap-2">
              <SafeIcon icon={FiMessageCircle} /> Consult with Expert
            </button>
            <button className="flex-1 py-4 bg-white border border-gray-200 text-gray-700 rounded-xl font-bold hover:bg-gray-50 transition-all flex items-center justify-center gap-2">
              <SafeIcon icon={FiExternalLink} /> View Resources
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default TaskDetailModal;